import axios from "axios";
import { Markup } from "interweave";
import { Link } from "react-router-dom";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import noImage from "../../../../../assets/images/settings/no-image.png";
import PriceTag from "../../../../../assets/images/tagPrice.PNG";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import "./AdminGreetingsRegisteredList.css";
import Nodata from "../../../../../assets/Icon/Nodata.png";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
const AdminGreetingsRegisteredList = () => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);
  const [loading, setloading] = useState(true);
  const [greeting, setGreeting] = useState({});
  const [greetingList, setGreetingList] = useState([]);
  const [Checked, setChecked] = useState([]);
  const [regGreId, setregGreId] = useState([]);
  const [modalShowl, setModalShowl] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  const data = greetingList;
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };


  useEffect(() => {
    getGreetingStatus();
    getAllGreetingRegWithPayment();
  }, [modalShowl]);

  const getGreetingStatus = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get("/api/admin/greetings_star_status").then((res) => {
        if (res.data.status === 200) {
          setGreeting(res.data.greeting);
        } else {
          swal("error", "Data base Error", "error");
        }
        setloading(false);
      });
    });
  };

  const getAllGreetingRegWithPayment = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get("/api/admin/greetings_register_list_with_payment_complete")
        .then((res) => {
          if (res.data.status === 200) {
            setGreetingList(res.data.list);
            console.log(res.data.list)
          } else {
            swal("error", "Data base Error", "error");
          }
          setloading(false);
        });
    });
  };


  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          {Object.keys(greeting).length != 0 ? (
            <>
              <div className="row mx-2">
                <div className="col-md-7 mb-3">
                  <div className="card card-bg p-2">
                    <img
                      src={
                        greeting?.banner
                          ? imageCdnUrl+greeting?.banner
                          : noImage
                      }
                      alt=""
                      className=" img-fluid banner_re"
                    />
                  </div>
                </div>
                <div className="col-md-5 mb-3">
                  <div className="card card-bg p-2">
                    <ReactPlayer
                      url={
                        greeting?.video
                          ?  videoCdnUrl + greeting?.video
                          : ""
                      }
                      width="100%" // height="100%" playing={false}
                      volume={1}
                      height="330px"
                      controls={true}
                      autoPlay
                    />
                  </div>
                </div>
              </div>

              <div className="my-3 row mx-2">
                <div className="col-md-7 mb-3">
                  {currentItems.length !== 0 ? (
                    <>
                      <div className="row">
                        {currentItems.map((data, index) => (
                          <>
                            <div className="clo-sm-12 col-md-3 col-lg-3 mb-3">
                              <Link to={'/superstar-admin/greetings/view/'+ data.id} className="Link">
                                <div className="completedMeetupBlack card-bg">
                                  <img src={greeting?.banner ? imageCdnUrl+greeting?.banner : noImage} className="img-fluid image-hover-link" alt="" style={{ height: "200px", width: "100%" }}/>
                                  <div className="p-3">
                                    <div className="under-line-warning my-2"></div>
                                    <div className="d-flex justify-content-between">
                                      {" "}
                                      <h6 className="text-white text-ellipsis Title_Link">
                                        {data?.purpose}
                                      </h6>
                                    </div>
                                    <p className="text-secondary head-line p-2 mt-2">
                                      <h6 className="text-warning fw-bold">
                                        {data?.request_time ? moment(data.request_time).format('dddd, Do MMMM YYYY, h:mm:ss A') : 'N/A'}
                                      </h6>
                                    </p>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </>
                        ))}
                      </div>

                      <div id="react-paginate">
                        <ReactPaginate
                          breakLabel="..."
                          nextLabel="next >"
                          onPageChange={handlePageClick}
                          pageRangeDisplayed={3}
                          pageCount={pageCount}
                          previousLabel="< previous"
                          renderOnZeroPageCount={null}
                          breakLinkClassName={"page-link"}
                          containerClassName={"pagination"}
                          pageLinkClassName={"page-link"}
                          previousLinkClassName={"page-link"}
                          nextLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="card card-bg head-line mb-3">
                        <div className="text-light d-flex justify-content-center">
                          <h4 className="text-white p-2">
                            Greetings Registered List
                          </h4>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center">
                        <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                          <img src={Nodata} alt="" className=" Nodata" />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="col-md-5">
                  <div className="card card-bg px-3 py-4">
                    <div className="card card-bg head-line mb-2">
                      <div className="text-light d-flex justify-content-center p-2">
                        <div className="faTrophy">
                          <i className="fas fa-trophy"></i>
                        </div>
                        <h4 className="mx-3 text-white p-2">
                          {greeting?.title}
                        </h4>
                      </div>
                    </div>
                    {/* <h4 className="text-light">{greeting?.title}</h4> */}
                    <p className="text-light pt-1">
                      <Markup content={greeting?.instruction} />
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                        style={{ width: "100%" }}
                      >
                        <span>
                          <img src={PriceTag} alt="" className="PriceTage" />
                        </span>
                        <div className=" mx-2 ">
                          <span className="text-light buTon-ab ">Cost</span>
                          <br></br>
                          <span className="text-info fw-bold buTon-abc">
                            {greeting?.cost} $
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                        style={{ width: "100%" }}
                      >
                        <span>
                          <img src={PriceTag} alt="" className="PriceTage" />
                        </span>
                        <div className=" mx-2 ">
                          <span className="text-light buTon-ab ">
                            Minimum apply before
                          </span>
                          <br></br>
                          <span className="text-info fw-bold buTon-abc">
                            {greeting?.user_required_day} Day
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row justify-content-center align-items-center mx-2">
                <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                  <img src={Nodata} alt="" className=" Nodata" />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default AdminGreetingsRegisteredList;
